import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vrn6ys29wd: FaireBrandEntity = {
  token: "b_vrn6ys29wd",
  type: "brand",
  name: "Absorb-Lumen",
  avatarUrl:
    "https://cdn.faire.com/fastly/2e5876d9d499d39b80323eda1b31bd6a96272c9128f550ff67102a1fb1749f0d.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a4929eb071e7107aa43c6f17064bf2ae726c7dc98d924f7d48071e71ffc7123e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2e5876d9d499d39b80323eda1b31bd6a96272c9128f550ff67102a1fb1749f0d.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a4929eb071e7107aa43c6f17064bf2ae726c7dc98d924f7d48071e71ffc7123e.png",
  location: "64119, MO, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 16,
  isTopShop: true,
  isInsider: true,
  description:
    "Elene — a Kansas City mom — wanted to create kitchen towels that were not only functional and beautiful, but that brought light to the heart of the home. Each towel is thoughtfully designed to inspire camaraderie, spark conversation, and stir up cherished memories around the kitchen table.\n\nOur Kitchen Mission:\nAt Absorb-Lumen, we believe the kitchen is where love and generosity begin. For every two towels sold, one is donated to local families and nonprofits in need. It’s our way of keeping kindness circulating — one home, one towel, one story at a time.\n\nElene’s ultimate purpose is to build a business that benefits the local community and sets a positive example for her boys and others — showing that true success comes from giving back and creating light wherever you go.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:13.384Z",
    importedBy: "entity-db-cli",
  },
};
